import React, { Component } from "react";
import { Helmet } from "react-helmet";
import { domain } from "../config/constants";
import ShopItem from "../components/ShopItem";

class Shop extends Component {
  state = {
    shopItems: [],
    show: 10,
  };

  getProducts = () => {
    fetch(`${domain}/api/shop/all`)
      .then((res) => {
        return res.json();
      })
      .then((shopItems) => {
        shopItems.sort(function (a, b) {
          return a.order - b.order;
        });
        this.setState({ shopItems });
      });
  };
  showMore = () => {
    let show = this.state.show + 6;
    this.setState({ show });
  };

  componentDidMount() {
    this.getProducts();
    this.props.setLocation("Shop");
  }

  render() {
    return (
      <div className="main">
        <Helmet>
          <title>Shop | Aya Brackett Photography</title>
          <meta name="description" content="Fine art prints and products by Aya Brackett, editorial and commercial photographer based in Oakland, CA." />
        </Helmet>
        <div className="content shop">
          {this.state.shopItems.map((item, i) => (
            <ShopItem key={i} item={item}></ShopItem>
          ))}
        </div>
      </div>
    );
  }
}

export default Shop;
